import styled from 'styled-components'

export const TableHeader = styled.div`
  display: contents;
`
